import { runCooperatively } from './cooperative';
import { jsonChunks, type JsonChunkOptions } from './jsonChunks';

/** Native JSON format, without a project-sized UTF-16 string. */
export async function jsonBlob(
  value: unknown,
  options: JsonChunkOptions & { maxBytes?: number } = {},
): Promise<Blob> {
  if (
    options.maxBytes !== undefined &&
    (!Number.isSafeInteger(options.maxBytes) || options.maxBytes < 0)
  )
    throw new RangeError('Invalid JSON byte limit');
  const parts: BlobPart[] = [];
  const encoder = new TextEncoder();
  let bytes = 0;
  function* write(): Generator<void> {
    for (const chunk of jsonChunks(value, { pretty: true, ...options })) {
      // Let the browser own each bounded Blob part instead of retaining every
      // project-sized byte buffer in the renderer until the final concatenation.
      const encoded = encoder.encode(chunk);
      bytes += encoded.byteLength;
      if (options.maxBytes !== undefined && bytes > options.maxBytes)
        throw new RangeError('JSON byte limit exceeded');
      parts.push(new Blob([encoded.buffer as ArrayBuffer]));
      yield;
    }
  }
  await runCooperatively(write());
  return new Blob(parts, { type: 'application/json' });
}
